import React from 'react';
import { Table, Spin } from 'antd';
import { ParAssetCatalogResidualValue } from 'services/assetconfig';
import { toPercentage } from 'utils/utils';

interface CrossTableProps {
    data: ParAssetCatalogResidualValue[];
}

const CrossTable: React.FC<CrossTableProps> = ({ data }) => {
    // Step 1: Get distinct max mileage values for the rows
    const maxMileageValues = Array.from(new Set(data.map((item) => item.mileagemax))).sort((a,b)=> a-b);

    // Step 2: Get distinct max month values for the columns
    const maxMonthValues = Array.from(new Set(data.map((item) => item.monthsmax)));

    // Step 3: Create the data source for the table, calculating rvpercentage or other values for each intersection
    const dataSource = maxMileageValues.map((maxMileage) => {
        const rowData: any = { maxMileage };

        maxMonthValues.forEach((maxMonth) => {
            // Find the corresponding data for the maxMileage and maxMonth intersection
            const intersectionData = data.find(
                (item) => item.mileagemax === maxMileage && item.monthsmax === maxMonth
            );
            rowData[maxMonth] = intersectionData ? intersectionData.rvpercentage : '-';
        });

        return rowData;
    });

    // Step 4: Define the table columns
    const tableColumns = [
        {
            title: 'Mileage',
            dataIndex: 'maxMileage',
            key: 'maxMileage',
        },
        ...maxMonthValues.map((maxMonth) => ({
            title: `${maxMonth} Months`,
            dataIndex: maxMonth,
            key: maxMonth,
            render:toPercentage,
            
        })),
    ];

    return (
        <Spin spinning={data.length === 0}>
            <Table
                dataSource={dataSource}
                columns={tableColumns}
                rowKey="maxMileage"
                pagination={false}
                bordered
                scroll={{ x: 'max-content' }}
            />
        </Spin>
    );
};

export default CrossTable;